import { Link, useSearchParams } from 'react-router-dom';
import { MODEL_TYPES, RENDER_STATUS, RENDER_STATUS_OPTIONS } from '../constants/constants';
import { LIVE_FURNISH } from '../constants/projectConstants';
import {
  ADMIN_MY_PRODUCTS_ROOMS,
  ADMIN_MY_PRODUCTS_ROOMS_DETAILS,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  TEMPLATES_DETAILS,
  TEMPLATES_DETAILS_V2,
  TEMPLATES_ROUTE,
  TEMPLATES_ROUTE_V2,
} from '../constants/routePathConstants';
import { checkIfMemberHaveEditorAccess, useUserContext } from '../contexts/UserContext';
import { getCuratorRoomPath } from '../helpers/urlHelper';
import { useTemplateActions } from '../hooks/useTemplateActions';
import ThumbnailCardUI, { ACTION } from './ThumbnailCardUI';
import { icons } from '../assets';
import { dispatcher } from '../helpers/projectHelper';
import { setTemporaryPreventBackupPopup } from '../redux/slicers/admin/curatorSlicer';
import { RENDER_IMAGE_TYPE } from '../constants/renderPreviewConstants';
import { Mixpanel, MxEvent } from './Mixpanel';
import ThumbnailCardV2 from './ThumbnailCardV2';
const { InfoIcon } = icons;

export const ThumbnailCardLightroom = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  to = '',
  hideFavourite,
  onEdit,
  onEditInfo,
  modelType = MODEL_TYPES.LIGHTROOM,
  curatorProp,
  designV2,
  showMenu,
  redirect,
  ...rest
}) => {
  const [params] = useSearchParams();
  const {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    onEditInfo: _onEditInfo,
  } = useTemplateActions({
    item: data,
  });

  const { canAccessLiveOnAppData, currentUser, isEditor } = useUserContext();
  const isTemplate = modelType === MODEL_TYPES.TEMPLATES;

  const cameraName = data?.images?.[0]?.cameraName;
  const url = getCuratorRoomPath(data.id, {
    cameraName: cameraName,
    propId: curatorProp,
  });
  const secondLine =
    (data?.owner_organization_details?.id !== LIVE_FURNISH.id &&
      data?.owner_organization_details?.name) ||
    '';

  // to remove the member details from the card if the rooms are created from LOA
  const tempData = Object.assign({}, data);
  tempData.member_details = {};
  const updatedData = isTemplate && canAccessLiveOnAppData() && data?.is_custom ? data : tempData;

  const isFilmicImgType = data?.img_type === RENDER_IMAGE_TYPE.FILMIC;
  const updatedImages = data?.images?.map((a) => {
    if (isFilmicImgType) {
      return {
        ...a,
        thumbnail: a?.filmic_thumbnail || a?.thumbnail,
      };
    }
    return {
      ...a,
      thumbnail: a?.thumbnail,
    };
  });

  const handleEditInfo = onEditInfo || _onEditInfo;

  // showing camera angle thumbnail for live on app room
  const thumbnail = data?.is_custom
    ? isFilmicImgType
      ? data?.images?.[0]?.filmic_thumbnail
      : data?.images?.[0]?.thumbnail || data?.thumbnail
    : data?.thumbnail;

  const preventCuratorBackupOpen = () => {
    dispatcher(
      setTemporaryPreventBackupPopup({
        type: 'room',
        id: data.id,
      })
    );
  };
  const handleMixPanelOpenProject = (Project_opened_from) => {
    Mixpanel.track(true, MxEvent.EDIT_IN_3D_TEMPLATE, {
      template_id: data?.id,
      template_name: data?.name,
      template_angle_name: '',
    });
    
    Mixpanel.track(true, MxEvent.CURATOR_STARTED, {
      'Curator project type': 'template',
      'Curator opened from': Project_opened_from,
      'Room id': data?.id,
      'Room name': data?.name,
      'Room isFavourite': data?.is_favourite,
      'Room creator id': data?.member_details?.id,
      'Room creator name': data?.member_details?.name,
      'Room creator email': data?.member_details?.email,
      'Room created at': data?.created_at,
    });
  };
  const handleEdit = () => {
    if (!checkIfMemberHaveEditorAccess()) return;

    if (onEdit) {
      onEdit?.();
    } else {
      handleMixPanelOpenProject('Edit button on lightroom');
      handleOpenCurator();
      window.open(url, '_blank');
    }
  };

  to = to + `?${params}`;

  let LOA_Status = null;
  if (data?.is_custom) {
    const s = RENDER_STATUS_OPTIONS.find((a) => a.value === data?.status);
    if (s && s.value !== RENDER_STATUS.STATUS_NOT_DONE && s.value !== RENDER_STATUS.STATUS_DONE) {
      LOA_Status = s;
    }
  }

  const handleOpenCurator = () => {
    preventCuratorBackupOpen();
  };

  const titleProps = !redirect ? null: {
    as: Link,
    target: '_blank',
    to: url,
    onClick: (e) => {
      if (!checkIfMemberHaveEditorAccess()) {
        e.preventDefault();
        return;
      }
      handleMixPanelOpenProject('Title of template thumbnail');
      handleOpenCurator();
    },
  };

  return designV2 ? (
    <ThumbnailCardV2
      onFavouriteChange={onFavouriteToggle(data)}
      onSelect={onSelect}
      selected={selected}
      isFavourite={data.is_favourite}
      hideFavourite={hideFavourite}
      favouriteLoading={favouriteLoading}
      titleProps={titleProps}
      data={data}
      id={data?.id}
      name={data?.name}
      thumbnail={data?.thumbnail || updatedImages?.[0]?.thumbnail}
      images={updatedImages}
      date={data?.created_at}
      userCard
      showMenu={showMenu}
      showCheckbox
      isFavouriteIcon
      onEdit={handleEdit}
      savePreviousRoute
      onEditInfo={isEditor ? handleEditInfo : null}
      onShare={onShare}
      onAddToCollection={addToCollection}
      redirect={redirect}
      redirectURL={`${isTemplate ? TEMPLATES_ROUTE_V2 : ADMIN_MY_PRODUCTS_ROOMS_V2}/${data?.id}`}
      redirectTarget="_self"
      secondLine={canAccessLiveOnAppData() && data?.is_custom ? '' : secondLine}
      {...rest}
    />
  ) : (
    <ThumbnailCardUI
      key={data.id}
      id={data.id}
      onEdit={handleEdit}
      onEditInfo={isEditor ? handleEditInfo : null}
      to={getTo(to, curatorProp)}
      thumbnail={thumbnail}
      images={updatedImages}
      name={data.name}
      isFavourite={data.is_favourite}
      favouriteLoading={favouriteLoading}
      date={
        isTemplate && canAccessLiveOnAppData() && data?.is_custom ? data?.created_at : undefined
      }
      onShare={onShare}
      onFavouriteChange={onFavouriteToggle(data)}
      size={size}
      titleProps={titleProps}
      fullWidth={fullWidth}
      onSelect={onSelect}
      selected={selected}
      onAddToCollection={addToCollection}
      hideFavourite={hideFavourite}
      data={updatedData}
      secondLine={canAccessLiveOnAppData() && data?.is_custom ? '' : secondLine}
      overlayText={LOA_Status}
      {...rest}
    />
  );
};

const getTo = (to, curatorProp) => {
  if (!to) return undefined;
  if (!curatorProp) return to;
  const query = `curatorProp=${curatorProp}`;
  let uto = to;
  if (window.location.search) {
    uto = `${uto}&${query}`;
  } else {
    uto = `${uto}${query}`;
  }

  return uto;
};
